import { useState } from "react";
import axios from "axios";

/**
 * Custom hook for bulk deletion with trash support.
 */
export function useBulkDelete() {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);

  /**
   * Delete documents from any collection.
   *
   * @param {string} collectionName - Name of the collection (e.g., 'chats', 'admissions')
   * @param {string} branch - Branch name
   * @param {Array<string>} ids - Array of document IDs to delete
   * @param {string} token - JWT token for authentication
   */
  const deleteDocuments = async ({ collectionName, branch, ids, token }) => {
    if (!ids || ids.length === 0) return;

    setLoading(true);
    setError(null);

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_COLLEGE_ERP_API}chat-messages`,
        {
          data: { collectionName, branch, ids },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setResults(response.data.results);
      return response.data.results;
    } catch (err) {
      console.error("Delete error:", err);
      setError(err.response?.data?.message || err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { deleteDocuments, results, loading, error };
}
